<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('notice.allnotifications')}}</h1>
						</div>
						<template v-if="lists.length > 0">
							<div class="message-container">
								<div class="message-items" v-for="item in lists" @click="openInfos(item)">
									<div class="message-titles">
										<div class="message-titles-txt">{{item.noticeTitle}}</div>
										<el-tag type="danger" size="mini" effect="dark" v-if="item.status == '0' || item.status === 0">{{$t('button.new')}}</el-tag>
									</div>
									<div class="message-contents">{{item.noticeContent}}</div>
									<div class="message-times">{{item.createTime}}</div>
								</div>
							</div>
							
							<!-- 分页组件 -->
							<div class="page-contrainer d-flex">
								<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next" :total="totalNum"
									:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
									@current-change="handleCurrentChange" @size-change="handleSizeChange"
									@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
							</div>
						</template>
						<template v-else>
							<div class="table-mobile-wrapper">
								<empty></empty>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="infos.noticeTitle" :visible.sync="dialogVisible" :width="isMobile ? '90%' : '600px'" :before-close="handleClose">
			<span>{{infos.noticeContent}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="closeInfos">{{$t('button.confirm')}}</el-button>
			</span>
		</el-dialog>
		<tabBar ref="tabBarRef"></tabBar>
	</div>

</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import { queryMsgAlllist,queryMsgdtl } from '@/api/message'
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				lists:[],
				currentPage:1,
				totalNum:0,
				pageSize:10,
				infos:{},
				dialogVisible:false,
				isMobile:false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getMessage()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getMessage() {
				var that = this
				var params = {
					pageNum:this.currentPage,
					pageSize:this.pageSize
				}
				queryMsgAlllist(params).then(res => {
					if (res.code == 200) {
						that.lists = res.data.list
						that.totalNum = res.data.total
					}
				});
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getMessage();
			},
			handlePrevClick(currentPage) {
				this.currentPage = currentPage;
				this.getMessage();
			},
			handleNextClick(currentPage) {
				this.currentPage = currentPage;
				this.getMessage();
			},
			openInfos(e) {
				var that = this
				var params = {
					noticeId:e.noticeId,
				}
				const loading = this.$loading({
				    lock: true,
				    text: 'Loading',
				    spinner: 'el-icon-loading',
				    background: 'rgba(0, 0, 0, 0.3)'
				});
				queryMsgdtl(params).then(res => {
					loading.close();
					if (res.code == 200) {
						if(e.noticeType == '3' || e.noticeType == '4' || e.noticeType == '5' || e.noticeType == '6'){
							that.openPage('order-infos?orderNo='+e.orderNo)
						}else{
							that.infos = res.data
							that.dialogVisible = true
						}
					}else{
						that.$message({
							 message: 'fail!',
							type: 'warning'
						});
					}
				});
			},
			closeInfos(){
				this.dialogVisible = false
			}
		}
	}
</script>

<style scoped>
	.message-container {
		width: 100%;
		height: auto;
		overflow: hidden;
	}
	.message-items {
		width: 100%;
		padding: 20px 25px;
		box-shadow: 3px 6px 6px rgba(0, 0, 0, .08);
		border: 1px solid #eee;
		border-radius: 6px;
		margin: 0 0 15px;
		cursor: pointer;
	}
	.message-titles {
		width: 100%;
		font-size: 14px;
		color: #212121;
		display: flex;
		height: 20px;
		align-content: flex-start;
	}
	.message-items .message-titles-txt {
		float: left;
		max-width: calc(100% - 48px);
		height: 100%;
		white-space: nowrap;
		overflow: hidden;          
		text-overflow: ellipsis;   
		margin-right: 8px;
	}
	.message-items .message-contents {
		width: 100%;
		margin: 6px 0;
		height: 20px;
		white-space: nowrap;
		overflow: hidden;          
		text-overflow: ellipsis; 
	}
	.message-items .message-times {
		font-size: 10px;
		color: #999;
	}
</style>
